import { Subject, Observable } from 'rxjs';
import { Project, ProjectEvent } from '../../model/project';
import {getCategoryPageData} from '../webclient/webclient';
import {
    getBuildingStates,
    getBuildingTypes,
    getCategories,
    getCountryTranslations,
    getCurrentDomain
} from "@/services/data/getCategoryPageData";

declare let category: number;

export class CategoryPageData {

    public paginatorType:string = 'paginator';

    private _data: Observable<ProjectEvent>;
    public get data(): Observable<ProjectEvent> {
        return this._data;
    }

    private _projects: Project[] = [];
    public get projects(): Project[] {
        return this._projects;
    }
    public set projects(v: Project[]) {
        this._projects = v;
        (this.data as Subject<ProjectEvent>).next({ event: 'fetch', data: v, paginator: null });
    }

    /*building state*/

    private _buildingStates: { id: string, value: string }[] = [];
    public get buildingStates(): { id: string, value: string }[] {
        return this._buildingStates;
    }
    public set buildingStates(v: { id: string, value: string }[]) {
        this._buildingStates = v;
    }

    private _buildingState: { id: string, value: string } | null = null;
    public get buildingState(): { id: string, value: string } | null {
        return this._buildingState;
    }

    public set buildingState(v: { id: string, value: string}  | null) {
        this._buildingState = v;
    }

    /*countries*/

    private _countries: { id: string, value: string }[] = [];
    public get countries(): { id: string, value: string }[] {
        return this._countries;
    }
    public set countries(v: { id: string, value: string }[]) {
        this._countries = v;
    }

    private _country: { id: string, value: string } | null = null;
    public get country(): { id: string, value: string } | null {
        return this._country;
    }

    public set country(v: { id: string, value: string}  | null) {
        this._country = v;
    }


    /* paginator*/
    private _paginator: {  current_page: string,  last_page: string ,  total: string  } | null = null;
    public get paginator(): {  current_page: string,  last_page: string ,  total: string } | null  {
        return this._paginator;
    }

    public set paginator(v: { current_page: string,  last_page: string ,  total: string } | null   | null) {
        this._paginator = v;
    }


    /*category**/

    private _categories: { id: string, value: string }[] = [];
    public get categories(): { id: string, value: string }[] {
        return this._categories;
    }
    public set categories(v: { id: string, value: string }[]) {
        this._categories = v;
    }

    private _category: { id: string, value: string } | null = null;
    public get category(): { id: string, value: string } | null {
        return this._category;
    }

    public set category(v: { id: string, value: string}  | null) {
        this._category = v;
    }

    getAllData(){
        let data ={
            buildingState: this._buildingState,
            category: this._category,
            country: this._country,
            paginator: this._paginator
        };
        return data;
    }

    clearProjects(){
        this._projects = [];
    }


    updateProjects(callback:any | null=null){
        (this._data as Subject<ProjectEvent>).next( {
            event: 'update-attributes',
            data: this.getAllData(),
            paginator: ''
        })
        getCategoryPageData(this._category, this._country, this._paginator, this._buildingState)
            .then(data => {
                //console.log(data);
                this._projects = this.paginatorType=="more" ? [...this._projects,...data.references.data] : data.references.data ;
                this._paginator = {
                    current_page: data.references.current_page,
                    last_page: data.references.last_page,
                    total: data.references.total,
                };
                (this._data as Subject<ProjectEvent>).next( {
                    data: this.projects,
                    paginator: this.paginator,
                    event: 'update-projects'
                });
                if(callback !== null){
                    callback();
                }
            })
            .catch(err => console.log(err));
    }


    constructor() {
        this._data = new Subject<ProjectEvent>();

        this._categories = getCategories();
        if(this._categories.length>0){
            this._category = this._categories[0];
        }

        this._countries = getCountryTranslations();
        if(this._countries.length>0){
            this._country = this._countries[0];
            $.each(this._countries, (index, c)=>{
                if(c.id == getCurrentDomain()){
                    this._country = c;
                }
            })

        }
        this._buildingStates = getBuildingStates();
        if(this._buildingStates.length>0){
            this._buildingState = this._buildingStates[0];
        }


        this.updateProjects();


    }

}
